/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Stat_CadenceInputs */

const en_ui_stat_cadence = /** @type {(inputs: Ui_Stat_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadence`)
};

const de_ui_stat_cadence = /** @type {(inputs: Ui_Stat_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kadenz`)
};

/**
* | output |
* | --- |
* | "Cadence" |
*
* @param {Ui_Stat_CadenceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_stat_cadence = /** @type {((inputs?: Ui_Stat_CadenceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Stat_CadenceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_stat_cadence(inputs)
	return de_ui_stat_cadence(inputs)
});